import type { PayloadAction } from "@reduxjs/toolkit";

import type { IActiveProduct } from "./models";

export const UPDATE = "activeProduct/update";
export function updateActiveProduct(
  payload: IActiveProduct,
): PayloadAction<IActiveProduct> {
  return {
    type: UPDATE,
    payload,
  };
}

export const CLEAR = "activeProduct/clear";
export function clearActiveProduct() {
  return {
    type: CLEAR,
  };
}
